import React from "react";
import "./welcome.css";
import { FaFaceSmileBeam } from "react-icons/fa6";

const Welcome = ({ data }) => {
  return (
    <div className="boxwelcome">
      <div>
        <FaFaceSmileBeam className="iconnotbill" />
      </div>
      <div className="boxtittlebill">
        <p className="tittlenotdatabill">
          ¡Hola, {data.name ? data.name : "usuario"}!
        </p>
      </div>
      <div className="boxexplainnotdatabill">
        <p className="explainotdatabill">Bienvenido al sistema</p>
      </div>
    </div>
  );
};

export default Welcome;
